import { createStore } from "solid-js/store";

const [networkStatusStore, setNetworkStatusStore] = createStore({
    isOnline: navigator.onLine,
});


window.addEventListener("offline", (e) => {
    setNetworkStatusStore("isOnline", false);
});

window.addEventListener("online", (e) => {
    setNetworkStatusStore("isOnline", true);
});

export { networkStatusStore };